/**
 * Neuro Messages Utility
 * Generates contextual messages for different focus activity types
 */

export type FocusActivityType =
  | 'visual_tracking'
  | 'pattern_memory'
  | 'calm_breathing'
  | 'delay_gratification'
  | 'audio_sequencing'
  | 'stillness_focus';

export interface NeuroMessageSet {
  intro: string;
  instruction: string;
  reward: string;
}

export function getNeuroMessage(activityType: FocusActivityType): NeuroMessageSet {
  switch (activityType) {
    case 'visual_tracking':
      return {
        intro: "Hi there! I'm Neuro, and I'm here to help you practice following things with your eyes.",
        instruction: "Watch the moving dot and try to follow it smoothly with your eyes. Don't move your head!",
        reward: "Amazing eye tracking! You earned a Focus Spark! ✨"
      };
    case 'pattern_memory':
      return {
        intro: "Hey friend! Let's play a memory game together.",
        instruction: "Watch the pattern I show you, then repeat it back to me!",
        reward: "Incredible memory power! You got a Memory Badge! 🧠"
      };
    case 'calm_breathing':
      return {
        intro: "Time to take some peaceful breaths with me!",
        instruction: "Breathe in slowly when the circle grows, breathe out when it shrinks.",
        reward: "Perfect breathing! You earned a Calm Star! 🌟"
      };
    case 'delay_gratification':
      return {
        intro: "Let's practice waiting patiently together!",
        instruction: "Wait for my signal before clicking the button. Good things come to those who wait!",
        reward: "Excellent patience! You got a Patience Trophy! 🏆"
      };
    case 'audio_sequencing':
      return {
        intro: "Listen carefully - we're going to play with sounds!",
        instruction: "Listen to the sequence of sounds, then repeat them in the same order.",
        reward: "Perfect listening! You earned Sound Waves! 🎵"
      };
    case 'stillness_focus':
      return {
        intro: "Let's practice being still and focused like a peaceful mountain!",
        instruction: "Stay as still as you can. Imagine you're a calm, strong mountain.",
        reward: "Amazing stillness! You got a Mountain Badge! ⛰️"
      };
    default:
      return {
        intro: "Let's practice focusing together!",
        instruction: "Follow the instructions and do your best!",
        reward: "Great job focusing! You earned a Focus Spark! ✨"
      };
  }
}
